export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14044.96e4d5aa.jpg";